import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCpADqIDorTAy6le_-ezIfOiW9L5ogitmQ",
  authDomain: "armazem-dvitto.firebaseapp.com",
  databaseURL: "https://armazem-dvitto.firebaseio.com",
  projectId: "armazem-dvitto",
  storageBucket: "armazem-dvitto.appspot.com",
  messagingSenderId: "11262325343",
  appId: "1:11262325343:web:8b82b4a75724c1852261ea",
  measurementId: "G-R2RFC167GZ"
};

const app = initializeApp(firebaseConfig);

getAnalytics(app);

export default app;
